/**
 * Router
 */

import * as found from 'found';
import * as React from 'react';

const anyFound = found as any;

export default anyFound.createConnectedRouter({
  render: anyFound.createRender({
    renderError: ({ error }) => (
      <div>
        {error.status === 404 ? 'Not found' : 'Error'}
      </div>
    ),
  }),
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/router/index.tsx